import {PaginationDTO} from '@/app/dto/PaginationDTO';

export class ListResult<T> {

    public items: T[];
    public pagination: PaginationDTO;

}
